import config from 'config';
import { action } from 'mobx';
import appStore from '@Stores/app';
import BaseStore, { LOADED, LOADING } from 'stores/BaseStore';
import HttpClient from 'utils/httpclient';

class PublisherStore extends BaseStore {
  constructor() {
    super('publishers', 'publisher', { site_model: true });
  }

  @action all(query = {}) {
    const params = { ...query, organizationId: appStore.site.organizationId }

    this.collection.readyState = LOADING;

    return (
      HttpClient.get(this.collectionURLAll, { params })
        .then(action(response => {
          const list = response.data;
          this.collection.objects = list;
          this.collection.count = list.length;
          this.collection.readyState = LOADED;
          return response;
        }))
        .catch(e => {
          this.collection.readyState = LOADED;
        })
    );
  }

  async allocations(publisher_id) {
    const params = { site_id: this.getCurrentSiteID() }
    this.entity.readyState = LOADING;
    const { data } = await HttpClient.get(`${config.api}/publisher/${publisher_id}/allocations`, { params })
    this.entity.readyState = LOADED;
    return data;
  }
}

export default new PublisherStore();
